import React, {useState} from 'react';
import {DateRange} from 'react-date-range';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalendar} from '@fortawesome/free-solid-svg-icons';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import {getLastDayOfTheMonth} from '../../helpers/utils';

export default function ReportFilterModule(props) {
  const {runReportHandler, metricsData} = props;
  const [showCalendar, setShowCalendar] = useState(false);

  const initialState = {
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      getLastDayOfTheMonth()
    ),
    key: 'selection',
    dateRangeDesc: 'This month'
  };

  const [state, setState] = useState([{...initialState}]);
  const getCurrentDateRange = (currentDate) => {
    return new Date(currentDate).toLocaleDateString('en-GB');
  };

  const onChangeHandler = (item) => {
    setState([item.selection]);
    if (
      item.selection.startDate !== initialState.startDate &&
      item.selection.endDate !== initialState.endDate &&
      item.selection.startDate !== item.selection.endDate
    ) {
      item.selection.dateRangeDesc = 'Custom';
      setShowCalendar(false);
    }
  };
  const runReport = () => {
    const params = {
      startDate: state[0].startDate,
      endDate: state[0].endDate
    };
    runReportHandler(params);
  };
  const downloadReport = () => {};
  return (
    <>
      <div className="d-flex justify-content-between">
        <div
          className="d-flex cursor-pointer"
          onClick={() => {
            setShowCalendar(!showCalendar);
          }}
        >
          <div className="border-right">
            <h6 className="m-0 p-2">{state[0].dateRangeDesc}</h6>
          </div>
          <div className="d-flex">
            <h6 className="m-0 p-2">{`${getCurrentDateRange(
              state[0].startDate
            )} - ${getCurrentDateRange(state[0].endDate)}`}</h6>
            <div className="my-auto">
              <FontAwesomeIcon icon={faCalendar} />
            </div>
          </div>
        </div>
        <div
          className={`dropdown-menu border border-rounded ${
            showCalendar ? 'd-block' : ''
          }`}
        >
          <DateRange
            editableDateInputs={true}
            onChange={onChangeHandler}
            moveRangeOnFirstSelection={false}
            ranges={state}
          />
        </div>

        <div className="d-flex">
          <button
            type="button"
            className="btn btn-sm btn-dark mx-1"
            onClick={() => {
              runReport();
            }}
          >
            {'Run Report'}
          </button>
          <button type="button" className="btn btn-sm btn-dark mx-1">
            <a
              className="text-decoration-none text-white"
              href={`data:text/csv;charset=utf-8,${escape(
                JSON.stringify(metricsData)
              )}`}
              download={`Report_${new Date().getTime()}.csv`}
            >
              {'Download Report'}
            </a>
          </button>
        </div>
      </div>
    </>
  );
}
